module.exports = __webpack_public_path__ + "static/media/LowIcon.c98b68fb.svg";